import introductionFinancialMathematicsEnglishImg from 'assets/images/booksOverview/introductionFinancialMathematicsEnglish.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const introductionFinancialMathematicsEnglish = {
  book: {
    id: 'finanzmathematik-en',
    format: FLIP_BOOKS,
    title: 'Introduction to Financial Mathematics for Beginners (english version)',
    subtitle: 'The mathematical foundations of investing',
    videos: 'Erwin W. Heri, Stefan Holzer, Nicolas Plain',
    layoutAndProduction: 'Erwin W. Heri',
    scope: { pages: 60, videos: 31 },
    price: [0, 82],
    introductions: [
      'Formulas are not a secret science',
      'Introduction to Financial Mathematics for Beginners starts with the compound interest formula',
      'No advanced mathematics, no prior knowledge of statistics',
      'One example is enough to show how much a formula can say',
    ],
    image: introductionFinancialMathematicsEnglishImg,
    overviewImg: introductionFinancialMathematicsEnglishImg,
  },
  bookIds: [55, 56],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([0, 82], [56, 55]),
};

export default introductionFinancialMathematicsEnglish;
